PJQ.views.settings.PrimeContractSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'prime-contracts'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Contracts",
            onSave: _.bind(function(signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.PrimeContractChangeOrderSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'prime-contract-change-orders'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Contract Change Orders",
            onSave: _.bind(function(signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});